import React from 'react';

const Header = () => {
    return (
        <div className='sticky top-0 h-20 z-20 bg-gray-800 shadow-md shadow-gray-600'>
            <div className="flex items-center justify-center h-full">
                <h1 className='text-base md:text-2xl font-medium text-gray-50'>Organize Your Life with Ease</h1>
            </div>
        </div>
    );
};

export default Header;